/* ------------------------------------------------------------------
 * dt-uploader : le téléverseur maison des fiches produit.
 * Remplace UploadKit (go Mehdi 11/08/2026). Aucune dépendance.
 *
 * Contrat avec le tracker (dt-tracker.liquid) : le widget dispatche
 *   dt:upload-opened        le client engage le téléverseur
 *   dt:upload-file-chosen   {files: n} fichiers choisis
 *   dt:upload-done          UN dépôt a abouti (le détecteur de clic
 *                           refusé s'en sert pour nommer sa cause)
 *   dt:upload-error         {text, status} un envoi a échoué
 *   dt:upload-fallback      panne serveur, achat autorisé quand même
 *
 * Contrat avec la commande : chaque dépôt réussi pose un
 *   <input type="hidden" name="properties[_Document N]" value="URL">
 * dans le formulaire d'achat principal, exactement là où UploadKit
 * posait les siens. Le « _ » (05/10/2026, demande Mehdi) cache la longue
 * URL dans la caisse Shopify, qui ne sait pas afficher un lien : le panier
 * et la page commande la rendent en lien « Document N ». Le CRM importe
 * les documents par leur URL, quel que soit le nom de la propriété. La barre collante recopie ce formulaire (fix du
 * 05/08), donc les deux chemins d'achat portent les documents.
 *
 * Panne (décision Mehdi 11/08) : si le serveur ne répond pas, on ne
 * bloque JAMAIS la vente. Le widget passe en repli, laisse acheter,
 * et marque la commande « documents à envoyer par email ».
 * ------------------------------------------------------------------ */
(function () {
  "use strict";

  var CONCURRENCY = 2;          // envois de front : la montée mobile sature vite
  var TIMEOUT_MS = 1800000;     // 30 min : laisse finir les documents volumineux sur mobile

  /* TROIS essais avant tout verdict, et le deuxieme n'envoie PAS la meme chose que
     le premier (24/09/2026). L'ancien code reessayait une seule fois, 1,5 s plus
     tard, avec le MEME objet File : quand c'est la LECTURE du fichier qui echoue,
     le second essai echoue pour la meme raison que le premier, et le widget se
     declarait indisponible en deux secondes. Desormais le 2e essai part d'une COPIE
     EN MEMOIRE (voir materialiser) et le 3e laisse passer une coupure courte.
     Budget total avant verdict : ~3,3 s d'attente + la sonde, soit moins de 8 s
     dans le pire cas, pendant lesquelles le bouton d'achat affiche « un instant ». */
  var BACKOFF_MS = [800, 2500];
  var MAX_ESSAIS = 3;
  /* Au-dela on ne recopie pas en memoire : 60 Mo dans le tas d'un telephone, c'est
     l'onglet qui tombe, et le client perd sa page produit. Tous les echecs observes
     portent sur des fichiers de 40 Ko a 700 Ko. */
  var COPIE_MEM_MAX = 60 * 1024 * 1024;
  var HEALTH_TIMEOUT_MS = 4000;

  function t(root, key) {
    var el = root.querySelector('script[data-dt-i18n]');
    if (!el) return key;
    try {
      var val = JSON.parse(el.textContent)[key];
      if (!val) return key;
      /* Le filtre de traduction echappe l'apostrophe (d&#39;envois). Sans ce
         decodage, l'entite s'affichait telle quelle dans la ligne du fichier. */
      var box = document.createElement("textarea");
      box.innerHTML = val;
      return box.value || val;
    } catch (e) { return key; }
  }

  /* Un nom long mange la place du statut : on coupe au milieu en gardant le
     debut, la fin et l'extension (facture_traduction_acte.pdf -> factu…acte.pdf).
     Le nom entier reste en infobulle. */
  function shortName(n) {
    n = String(n || "");
    if (n.length <= 26) return n;
    var dot = n.lastIndexOf(".");
    var ext = dot > 0 ? n.slice(dot) : "";
    var base = dot > 0 ? n.slice(0, dot) : n;
    var keep = 26 - ext.length - 1;
    if (keep < 6) return n.slice(0, 25) + "…";
    var head = Math.ceil(keep * 0.6);
    return base.slice(0, head) + "…" + base.slice(base.length - (keep - head)) + ext;
  }

  function dispatch(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) { /* vieux navigateur : la mesure passe, jamais la vente */ }
  }

  function storageGet(key) {
    try { return localStorage.getItem(key) || ""; } catch (e) { return ""; }
  }

  function fmtSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1).replace(".0", "") + " Mo";
    return Math.max(1, Math.round(bytes / 1024)) + " Ko";
  }

  /* Navigateur et systeme, en deux mots et SANS version : de quoi separer un
     Android d'un iPhone dans le brief, rien de plus. Aucune empreinte. */
  function navOs() {
    var u = "";
    try { u = navigator.userAgent || ""; } catch (e) {}
    return {
      nav: /Edg\//.test(u) ? "Edge" : /OPR\//.test(u) ? "Opera"
        : /SamsungBrowser/.test(u) ? "Samsung" : /Firefox\//.test(u) ? "Firefox"
        : /Chrome\//.test(u) ? "Chrome" : /Safari\//.test(u) ? "Safari" : "autre",
      os: /Android/i.test(u) ? "Android" : /iPhone|iPad|iPod/i.test(u) ? "iOS"
        : /Mac OS X/i.test(u) ? "macOS" : /Windows/i.test(u) ? "Windows"
        : /Linux/i.test(u) ? "Linux" : "autre"
    };
  }

  /* L'extension SEULE, jamais le nom : un nom de fichier est une donnee personnelle
     (« passeport-marie-dupont.pdf »), une extension ne l'est pas. */
  function extension(nom) {
    var m = String(nom || "").toLowerCase().match(/\.([a-z0-9]{1,8})$/);
    return m ? m[1] : "";
  }

  function nomErreur(e) {
    if (!e) return "";
    return String(e.name || e.constructor && e.constructor.name || e).slice(0, 40);
  }

  /* La trace, telle qu'elle voyagera : une seule ligne, lisible dans l'admin
     Shopify, analysable par le serveur. AUCUN nom de fichier, aucun contenu,
     aucun identifiant : cause, etape, extension, taille, essais, navigateur,
     systeme, langue de la boutique, et le code ou le nom de l'erreur. */
  function ligneDiag(d) {
    var ordre = ["cause", "etape", "ext", "ko", "essais", "lu", "mem", "http", "err", "nav", "os", "lang"];
    var out = [];
    for (var i = 0; i < ordre.length; i++) {
      var k = ordre[i], v = d[k];
      if (v === undefined || v === null || v === "") continue;
      out.push(k + ":" + String(v).replace(/[|\s]+/g, "_").slice(0, 40));
    }
    return out.join("|").slice(0, 300);
  }

  function init(root) {
    if (root.dataset.dtInit) return;
    root.dataset.dtInit = "1";

    var endpoint = (root.dataset.endpoint || "").replace(/\/$/, "");
    var required = root.dataset.required === "true";
    var maxFiles = parseInt(root.dataset.maxFiles, 10) || 30;
    var pagePath = root.dataset.page || location.pathname;

    // Mode « formulaire » (page devis, 11/08) : data-attach désigne le
    // formulaire cible et data-field-prefix nomme les champs (« Document N »
    // au lieu de properties[Document N]). Sans ces attributs, comportement
    // fiche produit inchangé : formulaire d'achat + propriétés de ligne.
    var attachSel = root.dataset.attach || "";
    var fieldPrefix = root.dataset.fieldPrefix || "";

    var input = root.querySelector('input[type="file"]');
    var drop = root.querySelector(".dt-uploader__drop");
    var list = root.querySelector(".dt-uploader__files");
    var msg = root.querySelector(".dt-uploader__msg");
    var fallbackNote = root.querySelector(".dt-uploader__fallback");

    var items = [];               // {id, file, name, size, status, pct, url, row, essais}
    var seq = 0;
    var degraded = false;         // panne serveur constatée : achat autorisé
    var openedSent = false;
    /* La trace du PREMIER echec de la page, figee. Figee pour deux raisons : c'est
       celui qui a fait basculer le client, et une valeur qui change ferait de chaque
       ajout au panier une ligne distincte au lieu d'un article en quantite 2. */
    var diagFige = "";
    var langue = (document.documentElement.lang || "").slice(0, 5);

    // ---- le formulaire cible : celui du data-attach, sinon l'achat ----
    function mainForm() {
      if (attachSel) return document.querySelector(attachSel);
      var section = root.closest('[id^="shopify-section"]') || document;
      var forms = section.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="add"]')) return forms[i];
      }
      return forms[0] || document.querySelector('form[action*="/cart/add"]');
    }

    // ---- propriétés de ligne : Document 1..N, renumérotées à chaque changement ----
    function syncProperties() {
      var form = mainForm();
      if (!form) return;
      var holder = form.querySelector("[data-dt-props]");
      if (!holder) {
        holder = document.createElement("span");
        holder.setAttribute("data-dt-props", "");
        holder.hidden = true;
        form.appendChild(holder);
      }
      holder.textContent = "";
      var n = 0;
      items.forEach(function (it) {
        if (it.status !== "done" || !it.url) return;
        n += 1;
        var inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = fieldPrefix ? fieldPrefix + " " + n : "properties[_Document " + n + "]";
        inp.value = it.url;
        holder.appendChild(inp);
      });
      if (degraded && !n) {
        var fb = document.createElement("input");
        fb.type = "hidden";
        fb.name = fieldPrefix ? "Documents" : "properties[Documents]";
        fb.value = t(root, "fallback_property");
        holder.appendChild(fb);
      }
      /* LE CHEMIN QUI SURVIT A TOUT (24/09/2026). La commande #4455 est partie avec
         « Per E-Mail zu senden (Upload nicht verfugbar) » sans qu'AUCUNE requete,
         pas meme un preflight, n'atteigne upload.docutrad.fr : chez ce client nos
         deux sous-domaines etaient injoignables, donc la trace envoyee au serveur
         ne pouvait pas arriver non plus. Celle-ci ne passe pas par notre reseau :
         elle voyage dans la commande elle-meme, par Shopify.
         Le prefixe « _ » la rend invisible au client (panier, caisse, confirmation,
         page commande : tous les gabarits sautent les proprietes en « _ ») et
         visible dans l'admin. Hors mode formulaire : le devis part chez un tiers. */
      if (diagFige && !fieldPrefix) {
        var dg = document.createElement("input");
        dg.type = "hidden";
        dg.name = "properties[_dt_diag]";
        dg.value = diagFige;
        holder.appendChild(dg);
      }
    }

    /* Un echec = une trace, une seule fois, par TOUS les chemins disponibles :
       1. l'evenement DOM, que le tracker releve et poste sur /collect ;
       2. la commande elle-meme (ci-dessus), seule voie qui survit a un reseau
          qui ne nous laisse pas sortir.
       Ni nom de fichier, ni contenu, ni identifiant. */
    function tracer(it, cause, etape, extra) {
      var no = navOs();
      var d = {
        cause: cause, etape: etape,
        ext: it ? extension(it.name) : "",
        ko: it && it.size ? Math.round(it.size / 1024) : (it ? 0 : ""),
        essais: it ? (it.essais || 0) : "",
        lu: it ? (it.lisible === true ? "oui" : it.lisible === false ? "non" : "?") : "",
        mem: it && it.corps ? "oui" : "",
        http: extra && extra.http ? extra.http : "",
        err: extra && extra.err ? extra.err : "",
        nav: no.nav, os: no.os, lang: langue
      };
      if (!diagFige) { diagFige = ligneDiag(d); syncProperties(); }
      dispatch("dt:upload-error", {
        text: (it && it.errKey) || "error_network",
        status: (extra && typeof extra.http === "number") ? extra.http : 0,
        bytes: it ? it.size : null, lisible: it ? it.lisible : null,
        cause: cause, etape: etape, ext: d.ext, essais: d.essais,
        memoire: !!(it && it.corps), err: d.err, nav: no.nav, os: no.os, lang: langue
      });
    }

    // ---- messages ----
    var msgTimer = null;
    function say(key, sticky) {
      msg.textContent = t(root, key);
      msg.hidden = false;
      if (msgTimer) clearTimeout(msgTimer);
      if (!sticky) msgTimer = setTimeout(function () { msg.hidden = true; }, 6000);
    }

    // ---- repli panne : DERNIER recours, et jamais definitif ----
    // Il n'est pose qu'apres MAX_ESSAIS envois reellement tentes et une sonde de
    // sante : le widget ne dit plus « indisponible » sans avoir essaye.
    function enterFallback(cause) {
      if (degraded) return;
      degraded = true;
      root.classList.add("is-fallback");
      fallbackNote.hidden = false;
      // ⚠️ On ne repeint PAS en « a envoyer par email » une ligne deja en erreur :
      // son message est le seul endroit qui dit au client QUOI FAIRE (rechoisir le
      // fichier, changer de reseau). Le bandeau de repli, juste en dessous, dit la
      // suite commerciale. Les deux se completent ; l'un effacait l'autre.
      items.forEach(function (it) {
        if (it.status === "uploading" || it.status === "queued") setStatus(it, "fallback");
      });
      syncProperties();
      dispatch("dt:upload-fallback", { cause: cause || "inconnu" });
    }

    /* Le repli se DEFAIT (24/09/2026). Jusqu'ici c'etait une porte a sens unique :
       un client dont la coupure durait trois secondes restait en « documents a
       envoyer par email » pour le reste de sa visite, meme si le depot suivant
       passait. Des qu'UN fichier arrive, la commande reprend ses liens. */
    function exitFallback() {
      if (!degraded) return;
      degraded = false;
      root.classList.remove("is-fallback");
      fallbackNote.hidden = true;
      items.forEach(function (it) { if (it.status === "fallback") setStatus(it, "error"); });
      syncProperties();
      dispatch("dt:upload-recovered");
    }

    /* Le serveur repond-il ? C'est CE qui separe « nos serveurs sont en panne » de
       « ma requete ne sort pas de chez moi », les deux causes vues le 24/09 :
       #4455 n'a produit aucune requete du tout, #4456 a obtenu son preflight en 204
       puis le POST n'est jamais arrive. Vu du client les deux disaient « reseau ».
       ⚠️ onload se declenche pour N'IMPORTE QUEL code : un 502 de nginx passait pour
       un serveur en vie. On lit le status. */
    function probeHealth(done) {
      var fini = false;
      var rendre = function (vivant) { if (fini) return; fini = true; done(vivant); };
      var x = new XMLHttpRequest();
      try {
        x.open("GET", endpoint + "/api/uploads/health");
        x.timeout = HEALTH_TIMEOUT_MS;
        x.onload = function () { rendre(x.status >= 200 && x.status < 400); };
        x.onerror = x.ontimeout = function () { rendre(false); };
        x.send();
      } catch (e) { rendre(false); }
    }

    // ---- rendu d'une ligne fichier ----
    function render(it) {
      if (!it.row) {
        it.row = document.createElement("li");
        it.row.className = "dt-uploader__file";
        it.row.innerHTML =
          '<span class="dt-uploader__fname"></span>' +
          '<span class="dt-uploader__fsize"></span>' +
          '<span class="dt-uploader__fstate" aria-live="polite"></span>' +
          '<button type="button" class="dt-uploader__retry" hidden></button>' +
          '<button type="button" class="dt-uploader__remove" aria-label=""></button>' +
          '<span class="dt-uploader__bar"><span class="dt-uploader__bar-fill"></span></span>';
        var nameEl = it.row.querySelector(".dt-uploader__fname");
        nameEl.textContent = shortName(it.name);
        nameEl.title = it.name;
        it.row.querySelector(".dt-uploader__fsize").textContent = fmtSize(it.size);
        var retryBtn = it.row.querySelector(".dt-uploader__retry");
        retryBtn.textContent = t(root, "retry");
        retryBtn.addEventListener("click", function () {
          it.essais = 0; it.corps = null; it.errKey = null; it.lectureErreur = "";
          start(it);
        });
        var removeBtn = it.row.querySelector(".dt-uploader__remove");
        removeBtn.setAttribute("aria-label", t(root, "remove") + " " + it.name);
        removeBtn.innerHTML = "&#10005;";
        removeBtn.addEventListener("click", function () {
          if (it.xhr) { try { it.xhr.abort(); } catch (e) {} }
          items = items.filter(function (o) { return o !== it; });
          it.row.remove();
          syncProperties();
          pump();
        });
        list.appendChild(it.row);
      }
      var state = it.row.querySelector(".dt-uploader__fstate");
      var fill = it.row.querySelector(".dt-uploader__bar-fill");
      var retry = it.row.querySelector(".dt-uploader__retry");
      it.row.dataset.status = it.status;
      // « Reessayer » n'a de sens que si le prochain essai peut reussir : coupure
      // reseau, plafond par IP, serveur en difficulte. Sur un format refuse ou un
      // fichier trop gros, le meme envoi donnera toujours le meme refus, et le
      // bouton ne fait qu'inviter le client a insister. Le 31/08/2026 a 12h51 un
      // client espagnol a clique HUIT fois en 40 secondes sur un format refuse
      // avant de comprendre qu'il fallait changer de fichier. Il lui reste la
      // croix pour retirer la ligne et la zone de depot juste au-dessus.
      // Les refus definitifs (le meme envoi donnera toujours le meme refus) ; le
      // fichier vide ou illisible en fait partie : il faut en choisir un autre.
      var refusDefinitif = it.errKey === "error_bad_type" || it.errKey === "error_too_large"
        || it.errKey === "error_unreadable" || it.errKey === "error_empty";
      // Une ligne passee en repli garde son bouton : le reseau du client peut etre
      // revenu, et un depot reussi fait ressortir toute la page du repli.
      retry.hidden = (it.status !== "error" && it.status !== "fallback") || refusDefinitif;
      if (it.status === "queued") { state.textContent = ""; fill.style.width = "0%"; }
      if (it.status === "uploading") {
        state.textContent = it.essais > 1 ? t(root, "status_retrying") : it.pct + " %";
        fill.style.width = it.pct + "%";
      }
      if (it.status === "done") { state.textContent = t(root, "status_done"); fill.style.width = "100%"; }
      if (it.status === "error") { state.textContent = t(root, it.errKey || "error_server"); }
      if (it.status === "fallback") { state.textContent = t(root, "status_fallback"); }
    }

    function setStatus(it, status) { it.status = status; render(it); }

    // ---- file d'envoi, 2 de front ----
    // En repli, un fichier JAMAIS tente part quand meme, seul : le client qui
    // rechoisit un document apres la panne a le droit a un essai, et c'est ce
    // qui permet de ressortir du repli. On ne relance pas ceux qui ont deja
    // echoue : on ne martele pas un serveur qu'on vient de declarer muet.
    function pump() {
      var plafond = degraded ? 1 : CONCURRENCY;
      var active = items.filter(function (o) { return o.status === "uploading"; }).length;
      items.forEach(function (it) {
        if (active >= plafond) return;
        if (it.status !== "queued") return;
        if (degraded && (it.essais || 0) > 0) return;
        active += 1; start(it);
      });
    }

    /* LA CORRECTION DU 24/09/2026, celle qui vise la commande #4456.
       Android Chrome, fichier de 322 Ko choisi depuis le selecteur : le preflight
       part et revient en 204 (vu dans le log nginx a 09:02:25), et le POST
       n'atteint JAMAIS le serveur. Le widget voyait un status 0 et disait
       « verifiez votre connexion », alors que la connexion allait bien.
       Ce que le navigateur refuse, c'est le CORPS : le File que rend le selecteur
       Android n'est pas un fichier, c'est une reference vers l'application qui le
       detient (Photos, Drive, Gmail — cette session arrivait de l'app Gmail). Si
       cette application regenere ou libere le fichier entre le choix et l'envoi,
       Chrome abandonne la requete avant de l'emettre.
       La parade : ne plus envoyer la reference mais une COPIE EN MEMOIRE. Le
       premier essai garde le File (aucun cout memoire, c'est le cas normal) ; des
       le deuxieme, on lit le fichier en entier et on envoie ce qu'on a lu.
       ⚠️ La sonde de lecture d'UN octet posee le 01/09 ne suffisait pas et disait
       « lisible: true » le 24/09 : le premier et le dernier octet se servent d'un
       cache que l'envoi complet, lui, n'a pas. Seule la lecture ENTIERE tranche. */
    function materialiser(it, done) {
      if (it.corps) return done(true);
      if (!it.size || it.size > COPIE_MEM_MAX) return done(false);
      var f = it.file;
      var ok = function (buf) {
        try {
          it.corps = new Blob([buf], { type: f.type || "application/octet-stream" });
          done(true);
        } catch (e) { it.lectureErreur = nomErreur(e); done(false); }
      };
      var ko = function (e) { it.lectureErreur = nomErreur(e) || "NotReadableError"; it.lisible = false; done(false); };
      try {
        if (f.arrayBuffer) { f.arrayBuffer().then(ok, ko); return; }
        var fr = new FileReader();
        fr.onload = function () { ok(fr.result); };
        fr.onerror = function () { ko(fr.error); };
        fr.readAsArrayBuffer(f);
      } catch (e) { ko(e); }
    }

    /* Le verdict, une fois les essais epuises. Il ne se prononce QUE la :
       - la lecture du fichier a echoue  -> c'est le fichier, on le dit, et on
         demande au client de le rechoisir. Ce n'est pas une panne, et ca ne fait
         pas basculer toute la page en repli ;
       - la sonde repond                 -> nos serveurs vont bien, c'est la sortie
         du client qui est bloquee (reseau d'entreprise, VPN, filtre DNS) ;
       - la sonde ne repond pas          -> on est injoignable pour lui.
       Dans les deux derniers cas le repli est pose : la vente ne se bloque jamais
       (decision de Mehdi du 11/08, confirmee le 14/08). */
    function verdict(it) {
      if (it.lectureErreur) {
        it.errKey = "error_unreadable";
        setStatus(it, "error");
        tracer(it, "fichier_illisible", "lecture", { err: it.lectureErreur });
        // La vente ne se bloque JAMAIS (Mehdi, 11/08). Un client dont le telephone
        // ne rend pas son unique fichier resterait sinon devant un bouton d'achat
        // qui refuse, sans repli : sa ligne garde son message, la commande part.
        enterFallback("fichier_illisible");
        pump();
        return;
      }
      probeHealth(function (vivant) {
        it.errKey = vivant ? "error_blocked" : "error_network";
        setStatus(it, "error");
        tracer(it, vivant ? "envoi_bloque" : "reseau_injoignable", "envoi", {});
        enterFallback(vivant ? "envoi_bloque" : "reseau_injoignable");
        pump();
      });
    }

    function start(it) {
      it.pct = 0;
      it.essais = (it.essais || 0) + 1;
      setStatus(it, "uploading");
      var fd = new FormData();
      fd.append("visitor_id", storageGet("dt_vid"));
      fd.append("session_id", storageGet("dt_sid"));
      fd.append("page", pagePath);
      // it.corps : la copie en memoire, posee des le 2e essai (voir materialiser).
      // Le nom est toujours donne explicitement, un Blob n'en porte pas.
      fd.append("file", it.corps || it.file, it.name);
      var x = new XMLHttpRequest();
      it.xhr = x;
      x.open("POST", endpoint + "/api/uploads");
      x.timeout = TIMEOUT_MS;
      if (x.upload) x.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          it.pct = Math.min(99, Math.round((e.loaded / e.total) * 100));
          render(it);
        }
      };
      x.onload = function () {
        it.xhr = null;
        var res = null;
        try { res = JSON.parse(x.responseText); } catch (e) {}
        if (x.status === 200 && res && res.ok && res.url) {
          it.url = res.url;
          setStatus(it, "done");
          exitFallback();          // un depot qui passe efface le repli
          syncProperties();
          dispatch("dt:upload-done");
          pump();
          return;
        }
        // Le serveur a REPONDU : sa reponse est le diagnostic, inutile d'insister.
        var key = "error_server", cause = "serveur";
        if (x.status === 413) { key = "error_too_large"; cause = "trop_lourd"; }
        else if (x.status === 415) { key = "error_bad_type"; cause = "format_refuse"; }
        else if (x.status === 429) { key = "error_rate"; cause = "plafond_ip"; }
        // 400 « empty » : le fichier est arrive vide. C'est le cas grossier du
        // fichier qu'Android promet sans savoir le fournir ; dire « reessayez »
        // enverrait le client huit fois dans le mur (incident du 31/08).
        else if (x.status === 400) { key = "error_empty"; cause = "fichier_vide"; }
        // 507 : notre disque est plein. Le client n'y peut rien et le prochain
        // essai echouera pareil : on passe en repli au lieu de le laisser insister
        // devant un bouton « Reessayer » sans issue.
        else if (x.status === 507) { key = "error_disk"; cause = "disque_plein"; }
        it.errKey = key;
        setStatus(it, "error");
        tracer(it, cause, "reponse", { http: x.status });
        if (x.status === 507) enterFallback("disque_plein");
        // 5xx : le serveur repond mais va mal ; s'il ne tient plus, on passe en repli.
        else if (x.status >= 500) probeHealth(function (vivant) { if (!vivant) enterFallback("serveur_muet"); });
        pump();
      };
      x.onerror = x.ontimeout = function () {
        it.xhr = null;
        reessayerOuConclure(it);
      };
      try { x.send(fd); } catch (e) {
        it.xhr = null;
        it.lectureErreur = it.lectureErreur || nomErreur(e);
        reessayerOuConclure(it);
      }
    }

    /* Le coeur du « jamais indisponible sans avoir essaye ».
       Essai 1 : le File tel quel. Essai 2 : une copie lue en memoire, apres 0,8 s.
       Essai 3 : la meme copie, apres 2,5 s, pour laisser passer une coupure courte.
       Ensuite seulement, verdict(). Si la lecture en memoire echoue, on sait deja
       que c'est le fichier et on ne perd pas un essai de plus. */
    function reessayerOuConclure(it) {
      if (items.indexOf(it) === -1) return;         // ligne retiree entre-temps
      if (it.essais >= MAX_ESSAIS) return verdict(it);
      var suite = function () {
        if (items.indexOf(it) === -1) return;
        setTimeout(function () {
          if (items.indexOf(it) !== -1) start(it);
        }, BACKOFF_MS[Math.min(it.essais - 1, BACKOFF_MS.length - 1)]);
      };
      // La ligne reste « en cours » : le client voit un nouvel essai, pas un echec
      // qui serait dementi une seconde plus tard.
      setStatus(it, "uploading");
      materialiser(it, function (lu) {
        if (!lu && it.lectureErreur) return verdict(it);   // c'est le fichier, pas le reseau
        suite();
      });
    }

    // ---- sélection de fichiers ----
    // Le fichier est-il REELLEMENT lisible ? (01/09/2026)
    //
    // Sur Android, le selecteur ne rend pas le fichier mais une reference vers
    // l'application qui le detient (Photos, Drive, appareil photo). `size` arrive
    // avec la reference, donc un fichier annonce a 329 Ko peut etre introuvable au
    // moment de l'envoi : le POST est abandonne avant de partir, et vu du widget
    // c'est indistinguable d'une coupure reseau. UN SEUL OCTET LU tranche, et il se
    // lit en quelques millisecondes.
    //
    // Volontairement NON BLOQUANT : on n'attend pas ce resultat pour envoyer, sinon
    // on ralentirait les 99 % de depots qui vont bien. Il est joint a l'echec, qui
    // arrive deux secondes plus tard, largement de quoi avoir la reponse.
    //
    // ⚠️ CE TEST NE TRANCHE PAS, et le 24/09/2026 l'a prouve : la commande #4456 a
    // echoue avec « lisible: true » sur les deux bouts. Deux octets se lisent dans
    // un cache que l'envoi complet n'a pas. Le test qui tranche est la lecture
    // ENTIERE tentee au 2e essai (materialiser) ; celui-ci reste pour le cas
    // grossier, gratuit, et parce qu'il repond avant meme le premier envoi.
    function verifieLisible(it) {
      it.lisible = null;   // null = pas encore su, et c'est une reponse honnete
      // ⚠️ LE DERNIER OCTET, PAS LE PREMIER, et c'est tout le sujet. Le 01/09 a
      // 16h22 un client a echoue avec un fichier de 692 Ko declare LISIBLE par la
      // premiere version de ce test, puis a reussi avec 95 Ko trente secondes plus
      // tard. Le debut d'un fichier est presque toujours disponible : c'est la
      // vignette, la version allegee que Google Photos garde en local quand il a
      // « libere de l'espace ». La FIN, elle, n'est la que si le fichier entier est
      // vraiment sur le telephone. D'ou le test des deux bouts, pour le meme prix.
      var taille = it.file.size || 0;
      var bouts = [it.file.slice(0, 1)];
      if (taille > 1) bouts.push(it.file.slice(taille - 1, taille));
      var restants = bouts.length;
      var lit = function (bout) {
        var ok = function () { restants -= 1; if (!restants && it.lisible !== false) it.lisible = true; };
        var ko = function () { it.lisible = false; };
        try {
          if (bout.arrayBuffer) { bout.arrayBuffer().then(ok, ko); return; }
          var fr = new FileReader();
          fr.onload = ok;
          fr.onerror = ko;
          fr.readAsArrayBuffer(bout);
        } catch (e) { ko(); }
      };
      try { bouts.forEach(lit); } catch (e) { it.lisible = false; }
    }

    function addFiles(fileList) {
      var files = Array.prototype.slice.call(fileList || []);
      if (!files.length) return;
      // La TAILLE de ce qui est choisi, pas seulement le nombre (01/09/2026).
      // Les echecs « reseau » de clients sont tous des Android, tous avec la meme
      // sequence : le navigateur passe en arriere-plan pendant le selecteur de
      // fichiers, revient, le fichier est choisi, et l'envoi echoue en deux secondes
      // SANS QUE LE POST ATTEIGNE JAMAIS LE SERVEUR (verifie dans les logs nginx le
      // 01/09 : le preflight OPTIONS passe, le POST n'arrive pas).
      //
      // ⚠️ `size` NE SUFFIT PAS a le voir, et c'est la lecon du 01/09 : c'est une
      // etiquette donnee par l'application qui detient le fichier. La cliente de
      // 15h54 annoncait 329 Ko pour un fichier qui n'est jamais parti. La taille se
      // garde (elle situe l'envoi) mais elle ne prouve rien : voir verifieLisible.
      var octetsChoisis = 0, illisibles = 0;
      files.forEach(function (f) {
        octetsChoisis += f.size || 0;
        if (!f.size) illisibles += 1;
      });
      dispatch("dt:upload-file-chosen", { files: files.length, bytes: octetsChoisis, illisibles: illisibles });
      var refused = 0;
      files.forEach(function (f) {
        if (items.length >= maxFiles) { refused += 1; return; }
        var dup = items.some(function (o) { return o.name === f.name && o.size === f.size; });
        if (dup) return;
        var it = { id: ++seq, file: f, name: f.name, size: f.size, status: "queued",
                   pct: 0, essais: 0, corps: null, lectureErreur: "" };
        verifieLisible(it);
        items.push(it);
        render(it);
      });
      if (refused) say("error_max_files");
      pump();
    }

    function markOpened() {
      if (openedSent) return;
      openedSent = true;
      dispatch("dt:upload-opened");
      setTimeout(function () { openedSent = false; }, 4000);
    }

    drop.addEventListener("click", function () { markOpened(); input.click(); });
    drop.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); markOpened(); input.click(); }
    });
    input.addEventListener("change", function () {
      addFiles(input.files);
      input.value = "";        // re-choisir le même fichier doit re-déclencher change
    });
    ["dragover", "dragenter"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-drag"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("is-drag"); });
    });
    drop.addEventListener("drop", function (e) {
      markOpened();
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });

    // ---- garde-fou d'achat : rien au panier sans document déposé ----
    // Document en phase CAPTURE : on passe avant les gestionnaires du thème
    // (actionAddToCart2) et après le tracker, qui écoute aussi en capture et
    // s'est enregistré avant nous ; le clic refusé reste donc bien mesuré.
    function canPurchase() {
      // Un envoi EN COURS bloque toujours, même quand le dépôt est facultatif
      // (page devis) : partir sans les liens ferait une demande sans documents.
      var moving = items.some(function (o) { return o.status === "uploading" || o.status === "queued"; });
      if (moving && !degraded) return "wait";
      if (!required || degraded) return "ok";
      return items.some(function (o) { return o.status === "done"; }) ? "ok" : "need";
    }
    document.addEventListener("click", function (e) {
      if (attachSel) return;   // mode formulaire : le garde-fou vit sur submit
      var btn = e.target && e.target.closest && e.target.closest('[name="add"]');
      if (!btn) return;
      var form = mainForm();
      if (!form || !form.contains(btn)) return;      // un autre produit (popup, etc.)
      var verdict = canPurchase();
      if (verdict === "ok") return;
      e.preventDefault();
      e.stopPropagation();
      say(verdict === "wait" ? "wait_uploads" : "need_docs", verdict === "need");
      root.scrollIntoView({ behavior: "smooth", block: "center" });
      root.classList.add("is-attention");
      setTimeout(function () { root.classList.remove("is-attention"); }, 1200);
    }, true);
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form !== mainForm()) return;
      var verdict = canPurchase();
      if (verdict === "ok") return;
      e.preventDefault();
      e.stopPropagation();
      say(verdict === "wait" ? "wait_uploads" : "need_docs", verdict === "need");
      root.scrollIntoView({ behavior: "smooth", block: "center" });
    }, true);
  }

  function boot() {
    var roots = document.querySelectorAll(".dt-uploader");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);   // éditeur de thème
})();
